import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './en.json';
import zh from './zh.json';

const normalizeLanguage = (language) => language?.toLowerCase().startsWith('zh') ? 'zh' : 'en';
const savedLanguage = localStorage.getItem('site-language');
const initialLanguage = normalizeLanguage(savedLanguage || window.navigator.language);

i18n.use(initReactI18next).init({

    resources: {
        en: {
            translation: en
        },
        zh: {
            translation: zh
        }
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    interpolation: {
        escapeValue: false //react已经做了html转义
    }
});

export default i18n;
